/* Keep the app's own markup and settings; delay its carousel work until needed. */
(() => {
  if (customElements.get('fr-deferred-reviews')) return;

  class DeferredReviews extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.button = this.querySelector('[data-reviews-load]');
      this.content = this.querySelector('[data-reviews-content]');
      this.placeholder = this.querySelector('[data-reviews-placeholder]');
      this.status = this.querySelector('[data-reviews-status]');
      this.button.addEventListener('click', () => {
        this.manual = true;
        this.load();
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.load();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mutations?.disconnect();
      clearTimeout(this.timeout);
    }

    load() {
      if (this.loading || this.loaded) return;
      this.observer?.disconnect();
      // Use Shopify's current app asset URL, so app upgrades do not leave a pinned version.
      const source = [...document.scripts].find(script =>
        /\/reputon-google-carousel-widget\.js(?:\?|$)/.test(script.src)
      );
      if (!source) {
        this.fail();
        return;
      }
      this.loading = true;
      this.button.disabled = true;
      this.status.textContent = 'Loading Google reviews…';
      this.setAttribute('aria-busy', 'true');
      this.content.replaceChildren(this.querySelector('template').content.cloneNode(true));
      // The app scans once at startup. Re-run its cached loader after mounting the widget;
      // its initialized attribute prevents other carousels from being initialized twice.
      this.mutations = new MutationObserver(() => {
        if (this.content.querySelector('.reputon-reviews-holder')) this.complete();
      });
      this.mutations.observe(this.content, { childList: true, subtree: true });
      this.timeout = setTimeout(() => this.fail(), 20000);
      const script = document.createElement('script');
      script.src = source.src;
      script.async = true;
      script.onerror = () => this.fail();
      script.onload = () => script.remove();
      this.loader = script;
      document.head.append(script);
    }

    complete() {
      this.loaded = true;
      this.loading = false;
      clearTimeout(this.timeout);
      this.mutations?.disconnect();
      this.removeAttribute('aria-busy');
      const restoreFocus = this.manual || this.placeholder.contains(document.activeElement);
      this.placeholder.hidden = true;
      this.dataset.reviewsState = 'loaded';
      if (restoreFocus) this.content.querySelector('a[href], button, [tabindex="0"]')?.focus();
    }

    fail() {
      if (this.loaded) return;
      this.loading = false;
      clearTimeout(this.timeout);
      this.mutations?.disconnect();
      this.loader?.remove();
      this.removeAttribute('aria-busy');
      this.content.replaceChildren();
      this.status.textContent = 'Reviews could not be loaded. Please try again.';
      this.button.textContent = 'Retry reviews';
      this.button.disabled = false;
      this.dataset.reviewsState = 'error';
    }
  }
  customElements.define('fr-deferred-reviews', DeferredReviews);
})();
